/* import __COLOCATED_TEMPLATE__ from './plaid-linking-consent-step.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { LogEvent } from '@square/dashboard-protos/models/squareup/bbfrontend/common/workflow/ui_elements/common';
import { Applet, Feature, Page, Target } from '@banking/ui/utils/bank-linking-cdp-events';
let PlaidLinkingConsentStep = (_class = class PlaidLinkingConsentStep extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "logEvents", _descriptor, this);
  }
  addClickListener() {
    const plaidLink = document.querySelector('.plaid-linking-modal__description a');
    plaidLink?.addEventListener('click', () => {
      this.logEvents.track(LogEvent.create({
        applet: Applet.Banking,
        feature: Feature.AddBankAccount,
        page: Page.PlaidPrimer,
        action: LogEvent.Action.CLICK,
        target: Target.Plaid
      }));
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addClickListener", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addClickListener"), _class.prototype), _class);
export { PlaidLinkingConsentStep as default };